// extracted by mini-css-extract-plugin
module.exports = {"colorD20":"StarsRating_colorD20__6CK8A"};